import Configs from './Configs';
import Events from '../Events';

export ConfigLoader from './Loader';

/**
 * @returns Configs
 */
export const createInstance = () => new Configs(Events);

const instance = new Configs(Events);

export const get = ::instance.get;
export const set = ::instance.set;
export const load = ::instance.load;

export default instance;



// WEBPACK FOOTER //
// ./src/Configs/index.js